import { isMultipartSetupOfSpecificType } from '@core/core/store'
import type {
  MarkerSetupType,
  MultipartUploadedFile,
  MultipartUploadedFileSetupType,
} from '@core/core/types'

export function useNarrowType(
  uploadedFile: MultipartUploadedFile | undefined,
  settings: MultipartUploadedFileSetupType | undefined,
) {
  if (!isMultipartSetupOfSpecificType<MarkerSetupType>(uploadedFile, settings, 'marker')) {
    return null
  }

  return { uploadedFile, settings }
}
